// src/pages/faq/EliminarPregunta.js
import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'

function EliminarPregunta(props) {
	const { pregunta, mostrar, cancelar, eliminar } = props

	const handleClose = () => {
		cancelar()
	}

	const handleEliminar = () => {
		if (pregunta?.id) {
			eliminar(pregunta.id)
		}
	}

	if (!pregunta) {
		return null
	}

	// render
	return (
		<Modal show={mostrar} onHide={handleClose}>
			<Modal.Header closeButton>
				<Modal.Title>Eliminar Pregunta Frecuente</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Alert variant="danger">
					<i className="fa fa-exclamation-triangle me-2"></i>
					Está a punto de eliminar la siguiente pregunta frecuente. Esta acción no se puede deshacer.
				</Alert>

				<div className="p-3 bg-light rounded mb-3">
					<h6 className="text-muted mb-2">Pregunta:</h6>
					<p className="mb-0"><strong>{pregunta.pregunta}</strong></p>
				</div>

				<p className="mb-0">¿Está seguro que desea continuar?</p>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="outline-secondary" onClick={handleClose}>
					<i className="fa fa-times me-2"></i>
					Cancelar
				</Button>
				<Button variant="danger" onClick={handleEliminar}>
					<i className="fa fa-trash me-2"></i>
					Eliminar
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default EliminarPregunta